import React from 'react';
import { Lightbulb, MousePointer, Rocket } from 'lucide-react';

import './HowItWorks.css';

function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: <Lightbulb size={32} />,
      title: 'Get Personalized Ideas',
      description:
        'Receive ideas matched to your role, industry, and goals—on your schedule (daily, every 2-3 days, or weekly). Each idea is pulled from trending discussions in your niche, so your posts feel current and relevant.',
    },
    {
      number: '02',
      icon: <MousePointer size={32} />,
      title: 'Choose Your Angle',
      description:
        'Pick the idea you like, then select a category (insights, lessons, trends, stories) and tone (professional, casual, thought-provoking). The system handles category rotation to keep your profile multi-dimensional.',
    },
    {
      number: '03',
      icon: <Rocket size={32} />,
      title: 'Publish in 60 Seconds',
      description:
        'Get your polished draft delivered via email in 60 seconds. Edit if you want, or post as-is. No dashboards, no logins—just fast, simple publishing directly from your inbox.',
    },
  ];

  return (
    <section className='how-it-works' id='how-it-works'>
      <div className='how-it-works-container'>
        <div className='how-it-works-header'>
          <h2 className='how-it-works-title'>How It Works</h2>
          <p className='how-it-works-subtitle'>
            A three-step system that turns industry conversations into your
            authentic content
          </p>
        </div>

        <div className='steps-container'>
          {steps.map((step, index) => (
            <div key={index} className='step'>
              <div className='step-number'>{step.number}</div>
              <div className='step-icon'>{step.icon}</div>
              <h3 className='step-title'>{step.title}</h3>
              <p className='step-description'>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
